import { render, staticRenderFns } from "./ProfilePersonalInfoView.vue?vue&type=template&id=11b9bb51&"
import script from "./ProfilePersonalInfoView.vue?vue&type=script&lang=js&"
export * from "./ProfilePersonalInfoView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports